import { css } from 'aphrodite';
import { Control, Controller, FormState } from 'react-hook-form';
import { FormFieldType } from '../../../../../extViewmodels';
import { IFormField, IPublicFileAttachment } from '../../../../models/Api';
import { FileUpload } from '../../../../containers/SurveyResponses/shared/FileUpload';
import { IFormValues } from '../utils';
import { CheckboxInput, SelectInput, StringInput } from './CustomFormInputs';
import { styleSheet } from './styles';

interface IProps {
	field: IFormField<string>;
	control: Control<IFormValues>;
	formState: FormState<IFormValues>;
	setValue: (name: keyof IFormValues, value: string | number | boolean) => void;
	token: string;
}

export const CustomFormFieldRenderer = ({ field, control, formState, setValue, token }: IProps) => {
	const renderInput = () => {
		switch (field.fieldType) {
			case FormFieldType.String:
				return <StringInput field={field} control={control} formState={formState} />;

			case FormFieldType.Option:
				return <SelectInput field={field} control={control} formState={formState} setValue={setValue} />;

			case FormFieldType.MultipleOptions:
				return <CheckboxInput field={field} control={control} formState={formState} setValue={setValue} />;

			case FormFieldType.FileUpload:
				return (
					<Controller
						// Cast needed: react-hook-form can't infer dynamic Record key paths
						name={`customProperties.${field.id}` as any}
						control={control}
						render={({ field: { value, onChange }, fieldState: { error } }) => (
							<FileUpload
								token={token}
								surveyType='donation'
								onFileSelected={onChange}
								files={(value as IPublicFileAttachment[]) ?? []}
								error={error}
							/>
						)}
					/>
				);

			default:
				return null;
		}
	};

	return (
		<div className={css(styleSheet.formControl)}>
			<label htmlFor={field.id} className={css(styleSheet.label)}>
				{field.label}
				{!field.isOptional ? (
					<>
						{' '}
						<span className={css(styleSheet.required)}>*</span>
					</>
				) : null}
			</label>
			{renderInput()}
		</div>
	);
};
